// extracted by mini-css-extract-plugin
module.exports = {"EntityLinkTooltip":"_8bsZx","EntityLinkTooltip_Image":"_1DwQh","EntityLinkTooltip_Content":"iavez","EntityLinkTooltip_EntityType":"ktgY4","EntityLinkTooltip_EntityTitle":"q7PMp"};